import { render, staticRenderFns } from "./paginator_new.vue?vue&type=template&id=af7fce18&scoped=true"
import script from "./paginator_new.vue?vue&type=script&lang=js"
export * from "./paginator_new.vue?vue&type=script&lang=js"
import style0 from "./paginator_new.vue?vue&type=style&index=0&id=af7fce18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af7fce18",
  null
  
)

/* custom blocks */
import block0 from "./paginator_new.vue?vue&type=custom&index=0&blockType=i18n&lang=yaml"
if (typeof block0 === 'function') block0(component)

export default component.exports